import { render, staticRenderFns } from "./Build.vue?vue&type=template&id=ae3a0fba&"
import script from "./Build.vue?vue&type=script&lang=js&"
export * from "./Build.vue?vue&type=script&lang=js&"
import style0 from "./Build.vue?vue&type=style&index=0&id=ae3a0fba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports